import React, { useMemo, useState } from 'react';
import FavouriteToggle from 'components/listing-card/favourite-toggle';
import Tooltip from 'components/control/tooltip';
import ShareIcon from 'components/icon/share-icon';
import styles from './style.module.scss';
import { buildClassName } from 'utils/build-class-name';
import type { TenantId } from '@tenants/types';
import { isExpTenant, isZoocasaTenant } from '@tenants/utils/which-tenant';
import { GTM_CLICK_ADDRESS_PAGE_SHARE_ICON } from 'constants/events';
import { AnalyticsController } from 'analytics/analytics-controller';
import { PROPERTY_FAVOURITED_SOURCE_ADDRESS_MODAL, PROPERTY_FAVOURITED_SOURCE_CAROUSEL } from '@bedrock/analytics';

interface ShareSaveListingProps {
  id: number;
  text: string;
  url: string;
  isModal?: boolean;
  showFavouriteToggle?: boolean;
  showShareButton?: boolean;
  tenantId: TenantId;
}

export default function ShareSaveListing(props: ShareSaveListingProps) {
  const { id, text, url, isModal, showFavouriteToggle = true, showShareButton = true, tenantId } = props;
  const [isTooltipActive, setIsTooltipActive] = useState(false);
  const isExpTheme = isExpTenant(tenantId);

  const analyticsProps = useMemo(() => ({
    source: isModal ? PROPERTY_FAVOURITED_SOURCE_ADDRESS_MODAL : PROPERTY_FAVOURITED_SOURCE_CAROUSEL,
  }), [isModal]);

  const share = () => {
    if (!isModal) {
      AnalyticsController.trackEvent(GTM_CLICK_ADDRESS_PAGE_SHARE_ICON);
    }
    // let url = host + listing.addressPathWithFallback;
    // url += url.match(/[?&]share/) ? '' : url.match(/\?/) ? '&share' : '?share';
    if (typeof navigator.share === 'undefined') {
      copyUrlToClipboard(url);
    } else {
      openNativeShareDialog(url);
    }
  };

  const copyUrlToClipboard = (url: string) => {
    navigator.clipboard.writeText(url).then(() => {
      setIsTooltipActive(true);
      setTimeout(() => {
        setIsTooltipActive(false);
      }, 3000);
    }).catch(error => {
      console?.error('Clipboard api not available: ' + error);
    });
  };

  const openNativeShareDialog = (url: string) => {
    navigator.share({ title: document.title, url, text: text }).catch(console.log);
  };

  return (
    <div className={buildClassName(styles.component, isExpTheme && styles.exp)}>
      {showShareButton && (
        <div className={styles.share} onClick={share}>
          <label><ShareIcon /></label>
          <Tooltip className={styles['custom-tooltip-position']} content="Link Copied" isActive={isTooltipActive} />
        </div>
      )}
      {showFavouriteToggle && <FavouriteToggle
        listingId={id}
        isInCarousel={true}
        isModal={isModal}
        isHeartExperiment={isZoocasaTenant(tenantId) && isModal}
        analytics={analyticsProps}
      />}
    </div>
  );
}
